import { persistor } from "../appStore/store";

const CHECK_INTERVAL_MS = 5 * 60 * 1000;
const BANNER_ID = "app-update-banner";

let knownVersion = null;

const fetchVersion = async () => {
  try {
    const res = await fetch(`/meta.json?ts=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return null;
    const data = await res.json();
    return data?.version || null;
  } catch {
    return null;
  }
};

const refreshAndPurge = async (button) => {
  button.disabled = true;
  button.textContent = "Refreshing...";
  try {
    await persistor.purge();
  } finally {
    window.location.reload();
  }
};

const showUpdateBanner = () => {
  if (document.getElementById(BANNER_ID)) return;

  const banner = document.createElement("div");
  banner.id = BANNER_ID;
  banner.style.cssText =
    "position:fixed;top:0;left:0;right:0;z-index:99999;background:#1976d2;" +
    "color:#fff;padding:10px 16px;text-align:center;font-family:sans-serif;" +
    "font-size:14px;display:flex;align-items:center;justify-content:center;gap:12px;";

  const text = document.createElement("span");
  text.textContent = "A new version of ArkChat is available.";

  const button = document.createElement("button");
  button.textContent = "Refresh now";
  button.style.cssText =
    "background:#fff;color:#1976d2;border:none;border-radius:4px;" +
    "padding:4px 12px;cursor:pointer;font-weight:600;";
  button.onclick = () => refreshAndPurge(button);

  banner.appendChild(text);
  banner.appendChild(button);
  document.body.prepend(banner);
};

const checkForUpdate = async () => {
  const latest = await fetchVersion();
  if (latest && knownVersion && latest !== knownVersion) {
    showUpdateBanner();
  }
};

export const initVersionCheck = async () => {
  knownVersion = await fetchVersion();
  if (!knownVersion) return;

  setInterval(checkForUpdate, CHECK_INTERVAL_MS);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") checkForUpdate();
  });
};
